import * as THREE from 'three';

export class EnvironmentMaterialController {
  private roadMats: THREE.MeshStandardMaterial[] = [];
  private buildingMats: THREE.MeshStandardMaterial[] = [];

  private roadBase: Map<THREE.MeshStandardMaterial, { rough: number; metal: number }> = new Map();
  private buildingBase: Map<THREE.MeshStandardMaterial, { emissive: THREE.Color; emissiveI: number }> = new Map();

  registerRoadMaterial(mat: THREE.MeshStandardMaterial) {
    if (this.roadMats.includes(mat)) return;
    this.roadMats.push(mat);
    this.roadBase.set(mat, { rough: mat.roughness, metal: mat.metalness });
  }

  registerBuildingMaterial(mat: THREE.MeshStandardMaterial) {
    if (this.buildingMats.includes(mat)) return;
    this.buildingMats.push(mat);
    this.buildingBase.set(mat, { emissive: mat.emissive.clone(), emissiveI: mat.emissiveIntensity });
  }

  setWetness(w: number) {
    const wet = Math.max(0, Math.min(1, w));
    for (const m of this.roadMats) {
      const base = this.roadBase.get(m)!;
      // wet streets: roughness down, metalness slightly up
      m.roughness = Math.max(0.12, base.rough * (1 - wet * 0.68));
      m.metalness = Math.min(0.35, base.metal + wet * 0.18);
      m.needsUpdate = true;
    }
  }

  setNightFactor(n: number) {
    const night = Math.max(0, Math.min(1, n));
    for (const m of this.buildingMats) {
      const base = this.buildingBase.get(m)!;
      // emissive windows stronger at night
      m.emissive.copy(base.emissive);
      m.emissiveIntensity = base.emissiveI + night * 0.9;
      m.needsUpdate = true;
    }
  }
}
